// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

// import RevealController from '@stimulus-components/reveal'
// application.register('reveal', RevealController)

import RailsNestedForm from '@stimulus-components/rails-nested-form'
application.register('nested-form', RailsNestedForm)

import Notification from '@stimulus-components/notification'
application.register('notification', Notification)

import RevealController from "./reveal_controller"
application.register("reveal", RevealController)

import MultiRevealController from "./multi_reveal_controller"
application.register("multi-reveal", MultiRevealController)

import RadioRevealController from "./radio_reveal_controller"
application.register("radio-reveal", RadioRevealController)

import ClientController from "./client_controller"
application.register("client", ClientController)

import OtherSelectController from "./other_select_controller"
application.register("other-select", OtherSelectController)

import MaskaController from "./maska_controller"
application.register("maska", MaskaController)

import MoneyController from "./money_controller"
application.register("money", MoneyController)

import ColeaderController from "./coleader_controller"
application.register("coleader", ColeaderController)

import SlimController from "./slim_controller"
application.register("slim", SlimController)

import SlimRemoteController from "./slim_remote_controller"
application.register("slim-remote", SlimRemoteController)

import PasswordPatternController from "./password_pattern_controller"
application.register("password-pattern", PasswordPatternController)

import TinyController from "./tiny_controller"
application.register("tiny", TinyController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import PermissionsController from "./permissions_controller"
application.register("permissions", PermissionsController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import StatementsController from "./statements_controller"
application.register("statements", StatementsController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import PerPageController from "./per_page_controller"
application.register("per-page", PerPageController)

import SearchFormController from "./search_form_controller"
application.register("search-form", SearchFormController)

import ExportSearchController from "./export_search_controller"
application.register("export-search", ExportSearchController)

import AnchorScrollController from "./anchor_scroll_controller"
application.register("anchor-scroll", AnchorScrollController)

import AutoDismissController from "./auto_dismiss_controller"
application.register("auto-dismiss", AutoDismissController)

// import CleaveController from "./cleave_controller"
// application.register("cleave", CleaveController)
//
//
//
// import HelloController from "./hello_controller"
// application.register("hello", HelloController)
//
// import NavtabController from "./navtab_controller"
// application.register("navtab", NavtabController)
//
// import NoteController from "./note_controller"
// application.register("note", NoteController)
//
// import ProductController from "./product_controller"
// application.register("product", ProductController)
//
//
// import StatesController from "./states_controller"
// application.register("states", StatesController)
//
// import StatsController from "./stats_controller"
// application.register("stats", StatsController)
//
// import TinyController from "./tiny_controller"
// application.register("tiny", TinyController)
//
// import UserController from "./user_controller"
// application.register("user", UserController)
